<template>
	<div class="control-buttons-tab">
		<div class="boxFixed">
			<div class="button-list">
				<BillsDetail
					:selectedRows="selectedRows"
					@success="success"
				></BillsDetail>
			</div>
			<div class="button-list">
				<InvoiceRecord :selectedRows="selectedRows" @success="success">
				</InvoiceRecord>
			</div>
			<div class="button-list">
				<a-button type="primary" size="small" @click="clearRecord"
					>{{ $t('billsReceivable.cancelBillingRegistration') }}</a-button
				>
			</div>
		</div>
		<template>
			<div>
				<a-modal
					:title="$t('billsReceivable.cancelBillingRegistration')"
					:visible="visible_resetmodel"
					@ok="confirmResetInvoice"
					@cancel="cancelResetInvoice"
				>
					<h3>{{ $t('billsReceivable.cancelInvoicingPrompt') }}</h3>
				</a-modal>
			</div>
		</template>
	</div>
</template>

<script>
import BillsDetail from "./bills-detail/bills-detail.vue";
import InvoiceRecord from "./invoice-record/invoice-record.vue";
import { searchReqParam } from "../../../utils/searchReqParam";
import { clearInvoiceRecord } from "../../../api/receivable";
import moment from "moment";

export default {
	name: "bills-buttons",
	components: { BillsDetail, InvoiceRecord },
	props: {
		selectedRows: {
			type: Array,
			default() {
				return [];
			},
		},
	},
	data() {
		return {
			req: searchReqParam(),
			params: {
				billingReportId: "",
				currentUserId: "",
			},
			visible_resetmodel: false,
		};
	},
	watch: {},
	created() {},
	mounted() {
		this.pageInit();
	},
	methods: {
		moment,
		pageInit() {
			console.log("pageinit");
		},
		// 点击 '取消开票登记' 按钮
		clearRecord() {
			if (this.selectedRows.length >= 1) {
				this.params.billingReportId = this.selectedRows[0].billingReportId;
				this.req.params = this.params;
				this.visible_resetmodel = true;
			} else {
				this.$message.error(this.$t('businessDispatch.feedbackTransportNode[0]'));
			}
		},
		success(msg) {
			this.$emit("success", msg);
		},
		// 二次确认是否 取消开票
		confirmResetInvoice() {
			clearInvoiceRecord(this.req).then((res) => {
				let temp = JSON.parse(res.data);
				console.log(temp);
				if (!temp.success || temp.code != 0) {
					this.$message.error(temp.msg);
					return;
				}
				this.$message.success(temp.msg);
				this.$emit("success", temp.msg);
			});
			this.visible_resetmodel = false;
		},
		cancelResetInvoice() {
			this.visible_resetmodel = false;
		},
	},
};
</script>
<style lang="less" scoped>
.boxFixed {
	float: left;
}
.button-list {
	display: inline-block;
	margin-right: 8px;
}
</style>
